// extracted by mini-css-extract-plugin
module.exports = {"root":"ShippingWidget_root__rYiJr"};